let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e01wV")).then(() => parcelRequire('3GdCb'));